'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import e$1 from "../defs/PresentationChart.es.js";
const e = a.forwardRef((o, r) => /* @__PURE__ */ a.createElement(p, { ref: r, ...o, weights: e$1 }));
e.displayName = "PresentationChartIcon";
const m = e;
export {
  m as PresentationChart,
  e as PresentationChartIcon
};
